// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4b7914a3","453":"68b58660","455":"3ca54bba","977":"9f8db0fd"}[chunkId] + ".chunk.js";
};